module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/experts_tablet-cd06330e70b13ff64f979f261180ed88.png";